// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6f5d1fc6] img{display:block;margin:1rem 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
